var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4646 15.9125L13.1777 12.4939C14.0228 11.4893 14.4859 10.2252 14.4859 8.90931C14.4859 5.83479 11.9844 3.33337 8.90992 3.33337C5.8354 3.33337 3.33398 5.83479 3.33398 8.90931C3.33398 11.9838 5.8354 14.4853 8.90992 14.4853C10.0641 14.4853 11.1641 14.1371 12.1045 13.4762L15.4163 16.9207C15.5547 17.0645 15.7409 17.1438 15.9405 17.1438C16.1293 17.1438 16.3085 17.0718 16.4445 16.9408C16.7334 16.6628 16.7427 16.2017 16.4646 15.9125ZM8.90992 4.78797C11.1825 4.78797 13.0313 6.63675 13.0313 8.90931C13.0313 11.1819 11.1825 13.0307 8.90992 13.0307C6.63736 13.0307 4.78858 11.1819 4.78858 8.90931C4.78858 6.63675 6.63736 4.78797 8.90992 4.78797Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchGray);
export default __webpack_public_path__ + "static/media/ic_search_gray.c650df5a3819eea2252aeb87261feacd.svg";
export { ForwardRef as ReactComponent };